import { render } from "./raw.vue?vue&type=template&id=5174cd16&ts=true"
import script from "./raw.vue?vue&type=script&lang=ts"
export * from "./raw.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__